import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { getCaseRecommendations } from "requests/homeowner/ho/index";
import MCard from "components/Shared/MCard.tsx";
import { MTable } from "components/Shared";

const CaseRecommendations = ({ controlNumber }) => {
  const [caseRecommendations, setCaseRecommendations] = useState();

  let mounted = useRef(true);

  useEffect(() => {
    getCaseRecommendations(controlNumber, setCaseRecommendations, mounted);
    return () => {
      mounted.current = false;
    };
  }, []);

  const getRecommendationRows = (recs) => {
    return recs.map(rec => {
      let copy = [...rec.categories];
      let name = copy.pop() ?? "";
      let cat = copy.pop() ?? "";
      return {
        level: rec.level,
        category: cat,
        count: rec.count,
        name: name
      };
    });
  };

  const getTable = () => {
    if (!caseRecommendations?.length)
      return <div>No Recommendations</div>;

    return (<MTable
      className="case-recommendations-table"
      columnDefinitions={[
        { name: "Level", dataSource: "level", style: { width: "20%" }},
        { name: "Category", dataSource: "category", style: { width: "30%" }},
        { name: "Count", dataSource: "count", style: { width: "10%" }},
        { name: "Name", dataSource: "name", style: { width: "40%" }},
      ]}
      data={getRecommendationRows(caseRecommendations)}
    />);
  };

  return (
    <MCard title="Recommendations" className="case-recommendations">
      {getTable()}
    </MCard>
  );
};

CaseRecommendations.propTypes = {
  controlNumber: PropTypes.number,
};

export default CaseRecommendations;